<template>
  <div class="announce">
    <v-head></v-head>
    <div class="contentBox">
      <div class="annpimceFlexBox">
        <div class="annleft">
          <p class="aTit">
            信息披露
          </p>
          <ul>
            <li :class="activate == 1 ? 'activate' : ''" @click="activate = 1">
              公司信息
            </li>
            <li :class="activate == 2 ? 'activate' : ''" @click="activate = 2">
              资质证明
            </li>
            <li :class="activate == 3 ? 'activate' : ''" @click="activate = 3">
              合作保险公司及产品
            </li>
            <li :class="activate == 4 ? 'activate' : ''" @click="activate = 4">
              自营平台
            </li>
            <li :class="activate == 5 ? 'activate' : ''" @click="activate = 5">
              保单验证方式
            </li>
            <li :class="activate == 6 ? 'activate' : ''" @click="activate = 6">
              分支机构查询
            </li>
            <li :class="activate == 7 ? 'activate' : ''" @click="activate = 7">
              客户服务及投诉渠道
            </li>
          </ul>
        </div>
        <div class="annright">
          <div class="corporate" v-show="activate == 1">
            <p>
              公司名称： <span>{{ Info.title }}</span>
            </p>
            <p>
              注册资本： <span>{{ Info.capital }}</span>
            </p>
            <p>
              成立时间：<span>{{ Info.establishment }}</span>
            </p>
            <p>
              法定代表人： <span>{{ Info.legal_person }}</span>
            </p>
            <p>
              统一社会信用代码： <span>{{ Info.credit_code }}</span>
            </p>
            <p>
              公司地址： <span>{{ Info.company_address }}</span>
            </p>
            <p>
              经营范围: <span>{{ Info.business_nature }}</span>
            </p>
          </div>
          <div class="certification" v-show="activate == 2">
            <div class="tabtop">
              <span
                @click="isActive = 0"
                :class="isActive == 0 ? 'active' : ''"
              >
                营业执照
              </span>
              <span
                @click="isActive = 1"
                :class="isActive == 1 ? 'active' : ''"
              >
                业务许可
              </span>
            </div>
            <div class="imgbox" v-if="Info">
              <el-image
                :src="Info.business_license[0].url"
                :preview-src-list="[Info.business_license[0].url]"
                v-show="isActive == 0"
              >
              </el-image>
              <el-image
                v-show="isActive == 1"
                :src="Info.business_permit[0].url"
                :preview-src-list="[Info.business_permit[0].url]"
              >
              </el-image>
            </div>
          </div>
          <div class="product" v-show="activate == 3">
            <el-table :data="tableData" size="small" style="width: 100%">
              <el-table-column
                prop="cooperation_start_time"
                label="合作开始时间"
              >
              </el-table-column>
              <el-table-column prop="cooperation_end_time" label="合作结束时间">
              </el-table-column>
              <el-table-column prop="proName" label="合作产品">
              </el-table-column>
              <el-table-column prop="title" label="备案名称"> </el-table-column>
              <el-table-column prop="companyName" label="承保公司">
              </el-table-column>
              <el-table-column prop="record_num" label="备案编号">
              </el-table-column>
              <el-table-column prop="insurance_clauses" label="条款下载">
                <template slot-scope="scope">
                  <a
                    :href="item.url"
                    download
                    target="_blank"
                    v-for="(item, index) in scope.row.insurance_clauses"
                    :key="index"
                    style="display:block"
                  >
                    《{{ item.name }}》
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="autotrophy" v-show="activate == 4">
            <el-image
              :src="Info.agent_img[0].url"
              :preview-src-list="[Info.agent_img[0].url]"
              v-if="Info"
            >
            </el-image>
            <p>
              网站：<a
                :href="Info.agent_domain"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ Info.agent_domain }}
              </a>
            </p>
            <p>
              中国保险协会备案信息查询链接：<a
                href="https://icid.iachina.cn/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://icid.iachina.cn/
              </a>
            </p>
          </div>
          <div
            class="textBox"
            v-show="activate == 5"
            v-html="Info.policy_verification_method"
          ></div>
          <div class="branch" v-show="activate == 6">
            <p v-for="(item, index) in Branch" :key="index">
              {{ index + 1 }}、{{ item.title }}：<a
                :href="item.domain"
                target="_blank"
                >点击查询各地分支服务机构</a
              >
            </p>
          </div>
          <div
            class="textBox"
            v-show="activate == 7"
            v-html="Info.customer_service"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vHead from "@/components/vhead";
import { getAgentInfo, getAgentBranch, getAgentCompany } from "@/api/announce";
export default {
  name: "announce",
  components: {
    vHead
  },
  data() {
    return {
      id: "",
      activate: 1, //标签页
      isActive: 0,
      Info: "",
      Branch: "",
      tableData: [{ id: 1 }]
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getAgentInfo();
    this.getAgentBranch();
    this.getAgentCompany();
  },
  methods: {
    getAgentInfo() {
      let that = this;
      getAgentInfo({ id: that.id })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.Info = res.data;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 添加分支机构
    getAgentBranch() {
      let that = this;
      getAgentBranch({ agent_id: that.id })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.Branch = res.data;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getAgentCompany(e) {
      let that = this;
      getAgentCompany({ agent_id: that.id })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.tableData = res.data;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="scss">
.announce {
  width: 100%;
  background-image: url("~@/assets/images/product/main-bg.png");
  background-size: cover;
  height: 100vh;
  background-color: #eff2f4;
  padding-top: 54px;
  .contentBox {
    width: 100%;
    max-width: 1200px;
    margin: 35px auto;
    background: #fff;
    box-shadow: 0px 0px 7px 2px rgba(235, 234, 234, 0.5);
    border-radius: 4px;
    border-top-left-radius: 10px;
    overflow: hidden;
  }
  .annpimceFlexBox {
    display: flex;
    justify-content: flex-start;
    .annleft {
      width: 200px;
      background: #f4f4f4;
      .aTit {
        background-image: url("~@/assets/images/product/annpincebg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        padding: 29px 30px;
        margin: 0;
        color: #fff;
        font-weight: 600;
      }
      ul {
        padding: 0;
        list-style: none;
        margin: 0 0 80px;
        li {
          padding: 10px 30px;
          font-size: 14px;
          font-weight: 500;
          color: #000000;
          margin-top: 15px;
          cursor: pointer;
          position: relative;
        }
        li.activate {
          background: #2b89ee0f;
        }
        li.activate:before {
          content: "";
          display: block;
          width: 2px;
          height: 40px;
          background: #2d8aee;
          border-radius: 0px 100px 100px 0px;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
    .annright {
      width: calc(100% - 200px);
      padding: 40px 35px;
      .corporate {
        p {
          font-size: 14px;
          margin: 0;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 48px;
          border-bottom: 1px solid #ededed;
          span {
            font-size: 14px;
            font-weight: 400;
            color: #000000;
          }
        }
      }
      .certification {
        .tabtop {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          border-bottom: 1px solid #e5e5e7;
          position: relative;
          span {
            font-size: 16px;
            font-weight: 400;
            color: #000;
            line-height: 22px;
            cursor: pointer;
            width: 90px;
            margin: 0 15px;
            padding-bottom: 13px;
            position: relative;
            text-align: center;
          }
          span:before {
            content: "";
            width: 80px;
            height: 2px;
            background: #2d8aee;
            border-radius: 2px;
            position: absolute;
            bottom: -1px;
            left: 50%;
            transform: translateX(-50%);
            transition: all 0.3s;
            opacity: 0;
          }

          span.active {
            color: #2d8aee;
          }

          span.active:before {
            opacity: 1;
          }
        }
        .imgbox {
          margin-top: 30px;
          overflow: hidden;
          padding: 5px;
          display: inline-block;
          border: 4px solid #e8e8e8;
          img {
            max-width: 400px;
            max-height: 300px;
          }
        }
      }
      .product {
        .el-table {
          th {
            font-size: 14px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            background: #e5ecf3;
          }
          td {
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
            a {
              color: #2d8aee;
            }
          }
        }
      }
      .autotrophy {
        .el-image {
          margin-bottom: 25px;
          img {
            max-width: 400px;
            max-height: 250px;
          }
        }
        p {
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 30px;
          margin: 0;
          a {
            color: #2d8aee;
          }
        }
      }
      .branch {
        p {
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 30px;
          margin: 0;
          a {
            color: #2d8aee;
          }
        }
      }
    }
  }
}
</style>
